"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BorderedRadio = exports.Radio = void 0;

var _debounce = _interopRequireDefault(require("debounce"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Flex = require("../../elements/Flex");

var _helpers = require("../../helpers");

var _styledSystem = require("styled-system");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A Radio button
 *
 * Spec: zpl.io/bAvnwlB
 */
var Radio = function Radio(props) {
  var children = props.children,
      disabled = props.disabled,
      hover = props.hover,
      name = props.name,
      _onSelect = props.onSelect,
      selected = props.selected,
      value = props.value,
      label = props.label,
      others = _objectWithoutProperties(props, ["children", "disabled", "hover", "name", "onSelect", "selected", "value", "label"]); // Ensures that only one call to `onSelect` occurs, regardless of whether the
  // user clicks the radio element or the label.


  var onSelect = _onSelect && (0, _debounce.default)(_onSelect, 0);

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    disabled: disabled,
    alignItems: "center",
    selected: selected,
    hover: hover,
    onClick: function onClick() {
      return !disabled && onSelect && onSelect({
        selected: !selected,
        value: value
      });
    }
  }, others), /*#__PURE__*/_react.default.createElement(RadioButton, {
    role: "presentation",
    border: 1,
    mr: 1,
    mt: "2px",
    mb: "-2px",
    selected: selected,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(InnerCircle, null)), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(Label, {
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(HiddenInput, {
    type: "radio",
    name: name,
    checked: selected,
    disabled: disabled,
    onChange: function onChange() {
      return !disabled && onSelect && onSelect({
        selected: !selected,
        value: value
      });
    }
  }), label ? label : children), label ? children : null));
};

exports.Radio = Radio;
Radio.displayName = "Radio";

/**
 * A radio button with a border
 */
var BorderedRadio = (0, _styledComponents.default)(Radio).withConfig({
  displayName: "Radio__BorderedRadio",
  componentId: "dpre3w-0"
})(["padding:", "px;border-radius:2px;border:1px solid ", ";transition:background-color 0.14s ease-in-out;:hover:not(:disabled){background-color:", ";}:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;}:not(:last-child){border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0;}"], (0, _helpers.space)(2), (0, _helpers.color)("black10"), (0, _helpers.color)("black5"));
exports.BorderedRadio = BorderedRadio;

var hoverStyles = function hoverStyles(_ref) {
  var selected = _ref.selected,
      hover = _ref.hover;
  var styles = "background-color: ".concat((0, _helpers.color)("black10"), ";");

  if (hover && !selected) {
    return (0, _styledComponents.css)(["", "{", ";}"], RadioButton, styles);
  }

  if (!selected) {
    return (0, _styledComponents.css)(["&:hover ", "{", ";}"], RadioButton, styles);
  }
};

var Container = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Radio__Container",
  componentId: "dpre3w-1"
})(["align-items:flex-start;cursor:", ";user-select:none;", ";"], function (_ref2) {
  var disabled = _ref2.disabled;
  return !disabled && "pointer";
}, hoverStyles);

var Label = _styledComponents.default.label.withConfig({
  displayName: "Radio__Label",
  componentId: "dpre3w-2"
})(["display:block;flex-grow:1;cursor:pointer;", ";"], function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && (0, _styledComponents.css)(["cursor:inherit;color:", ";"], (0, _helpers.color)("black10"));
});

var HiddenInput = _styledComponents.default.input.withConfig({
  displayName: "Radio__HiddenInput",
  componentId: "dpre3w-3"
})(["position:absolute;opacity:0;pointer-events:none;"]);

var InnerCircle = _styledComponents.default.div.withConfig({
  displayName: "Radio__InnerCircle",
  componentId: "dpre3w-4"
})(["width:", "px;height:", "px;border-radius:50%;position:relative;left:3px;top:3px;background-color:", ";"], (0, _helpers.space)(1), (0, _helpers.space)(1), (0, _helpers.color)("white100"));

var radioBackgroundColor = function radioBackgroundColor(_ref4) {
  var disabled = _ref4.disabled,
      selected = _ref4.selected;

  switch (true) {
    case disabled:
      return (0, _helpers.color)("black10");

    case selected:
      return (0, _helpers.color)("black100");

    default:
      return (0, _helpers.color)("white100");
  }
};

var radioBorderColor = function radioBorderColor(_ref5) {
  var disabled = _ref5.disabled,
      selected = _ref5.selected;
  return selected && !disabled ? (0, _helpers.color)("black100") : (0, _helpers.color)("black10");
};

var disabledInnerCircleBackgroundColor = function disabledInnerCircleBackgroundColor(_ref6) {
  var disabled = _ref6.disabled,
      selected = _ref6.selected;
  return disabled && !selected && (0, _helpers.color)("black10");
};

var RadioButton = _styledComponents.default.div.withConfig({
  displayName: "Radio__RadioButton",
  componentId: "dpre3w-5"
})(["", ";", ";background-color:", ";border-color:", ";width:", "px;height:", "px;min-width:", "px;min-height:", "px;border-radius:50%;transition:background-color 0.25s,border-color 0.25s;", "{background-color:", ";}"], _styledSystem.borders, _styledSystem.space, radioBackgroundColor, radioBorderColor, (0, _helpers.space)(2), (0, _helpers.space)(2), (0, _helpers.space)(2), (0, _helpers.space)(2), InnerCircle, disabledInnerCircleBackgroundColor);
//# sourceMappingURL=Radio.js.map